import styled from 'styled-components';

import { BodyProps } from './Body01';
import { getTypographyFontColor } from './helpers';

const Subtitle01 = styled.p<BodyProps>`
    font-family: ${ ({ theme }) => theme.type.regularFont };
    color: ${ getTypographyFontColor };
    font-size: 16px;
    letter-spacing: 0.15px;
    line-height: 24px;
    margin: 0;
    padding: 0;
`;

export default Subtitle01;
